export default __webpack_public_path__ + "media/src/assets/images/email-3d805bf550fa74d06238333cfdffc72f.svg";